import React from 'react';
import {observer} from 'mobx-react-lite';

import {CampaignTeaserSectionModel} from '../../../../generated/core';
import {MapTo} from '../../../infrastructure/compatibility/MapTo';
import {SectionWrapper} from './SectionWrapper';
import {XfCampaignTeaser} from '../../structure/main/XfCampaignTeaser';
import {TeaserSectionAuthoringView} from './teasers/common';
import {C} from '../../../registries/compatibilty';

/**
 * S142 Campaign Teaser
 */
const InternalCampaignTeaserSection = observer(function CTSP(
    props: CampaignTeaserSectionModel
): JSX.Element | null {
    const {
        contentLabels,
        contentId,
        anchorId,
        contentName,
        mboxId,
        validationMessages,
        validationError
    } = props;

    if (!C.isInEditor() && validationError) {
        return null;
    }

    return (
        <TeaserSectionAuthoringView
            anchorId={anchorId}
            emptyLabel="S142 Campaign Teaser Section"
            validationMessages={C.isInEditor() ? validationMessages : []}
            validationError={validationError}
        >
            <SectionWrapper
                mboxId={mboxId}
                sectionId={contentId}
                anchorId={anchorId}
                contentLabels={contentLabels}
                contentName={contentName}
            >
                {!validationError && <XfCampaignTeaser path="item" noElement />}
            </SectionWrapper>
        </TeaserSectionAuthoringView>
    );
});

export const CampaignTeaserSection = MapTo(
    'vwa-ngw18/components/editorial/sections/campaignTeaserSection',
    InternalCampaignTeaserSection
);
